import { render, staticRenderFns } from "./ArgesNavbar.vue?vue&type=template&id=465cc722&scoped=true&"
import script from "./ArgesNavbar.vue?vue&type=script&lang=ts&"
export * from "./ArgesNavbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465cc722",
  null
  
)

export default component.exports